import axios from "axios";
import { ClientClassificationType } from "models/client_classification_type";
import { ContatoType } from "models/contato_type";
import { EmpresaFilial } from "models/empresa_filial_type";
import { EnderecoType } from "models/endereco_type";
import { PessoaType } from "models/person_type";
import { PessoaContaFinanceiro } from "models/pessoa_conta_type";
import { UsuarioModel } from "models/user_model";
import { ViaCepType } from "models/via_cep_type";
import { useEffect, useRef, useState } from "react";
const useClients = () => {
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [classificacaoList, setClassificacaoList] = useState<
    ClientClassificationType[]
  >([]);
  const [tipoPessoaList, setTipoPessoaList] = useState<
    ClientClassificationType[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [showPessoa, setShowPessoa] = useState(false);
  const [errorCliente, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [clientes, setClientes] = useState<PessoaType[]>([]);
  const [filial, setFilial] = useState<PessoaType[]>([]);
  const [pessoaFilial, setPessoaFilial] = useState<EmpresaFilial[]>([]);
  const cancelRefPessoa = useRef();
  const cancelPessoaRef = useRef();
  const cancelDeleteRef = useRef();
  /* valores do cadastro de pessoa */
  const nomeClinteRef = useRef(null);
  const idTipoRef = useRef(null);
  const classificacaoRef = useRef(null);
  const documentoRef = useRef(null);
  const razaoSocialRef = useRef(null);
  const nomeFantasiaRef = useRef(null);
  const inscricaoMunicipalRef = useRef(null);
  const inscricaoEstadualRef = useRef(null);
  const contribuinteRef = useRef(null);
  const [errorTitleCliente, setErrorTitle] = useState("");
  const [errorMsgCliente, setErrorMsg] = useState("");
  const [client, setClient] = useState<PessoaType>(null);
  /* valores do cadastro de pessoa */

  /* valores do endereço */
  const [enderecoList, setEnderecoList] = useState<EnderecoType[]>([]);
  const [viaCepEnd, setViaCepEnd] = useState<ViaCepType>();
  const cepRef = useRef(null);
  const ruaRef = useRef(null);
  const numeroRef = useRef(null);
  const complementoRef = useRef(null);
  const bairroRef = useRef(null);
  const cidadeRef = useRef(null);
  const estadoRef = useRef(null);
  const principalRef = useRef(null);

  /* valores do endereço */

  /* valores do contato */
  const [contatoList, setContatoList] = useState<ContatoType[]>([]);
  const nomeContatoRef = useRef(null);
  const cargoContatoRef = useRef(null);
  const telefoneContatoRef = useRef(null);
  const emailContatoRef = useRef(null);
  const principalContatoRef = useRef(null);
  const cancelContatoRef = useRef(null);

  /* valores do contato */

  /* valores da conta */

  const [contaList, setContaList] = useState<PessoaContaFinanceiro[]>([]);
  const bancoRef = useRef(null);
  const agenciaRef = useRef(null);
  const tipoRef = useRef(null);
  const numeroContaRef = useRef(null);
  const titularRef = useRef(null);
  const tipoPessoaRef = useRef(null);
  const documentoContaRef = useRef(null);
  const descricaoRef = useRef(null);
  const obsRef = useRef(null)
  /* valores da conta */

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const showFormPessoa = (show: boolean) => {
    setShowPessoa(show);
    if (!show) {
      nomeFantasiaRef.current = null;
      nomeClinteRef.current = null;
      classificacaoRef.current = null;
      idTipoRef.current = null;
      documentoRef.current = null;
      razaoSocialRef.current = null;
      inscricaoEstadualRef.current = null;
      inscricaoMunicipalRef.current = null;
      contribuinteRef.current = null;
      setPessoaFilial([]);
      setEnderecoList([]);
      setContatoList([]);
      setClient(null);
      setContaList([]);
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setClientes(response.data);
    }
  };

  const loadClassificaocao = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa-classificacao/list/" +
        userData?.idEmpresa
    );
    if (response.data) {
      setClassificacaoList(response.data);
    }
  };

  const loadClientType = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa-tipo/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setTipoPessoaList(response.data);
    }
  };

  const loadContato = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/contato/list/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setContatoList(response.data);
    }
  };

  const loadEndereco = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/endereco/list/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setEnderecoList(response.data);
    }
  };

  const loadCEP = async (cep: string) => {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
    if (response.data) {
      setLoading((prev) => (prev = false));
      setViaCepEnd(response.data);

      const viaCepObj: ViaCepType = response.data;
      ruaRef.current = viaCepObj.logradouro;
      bairroRef.current = viaCepObj.bairro;
      cidadeRef.current = viaCepObj.localidade;
      estadoRef.current = viaCepObj.uf;
    }
  };

  const loadEmpresas = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFilial(response.data);
    }
  };

  const loadPessoaFilial = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pessoa/list/filial/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setPessoaFilial(response.data);
    }
  };

  const adicionarEndereco = () => {
    if (numeroRef.current.value === "" || cepRef.current.value === "") {
      showError("Erro!", "Preencha corretamente o endereço");
    } else {
      const endList: EnderecoType[] = enderecoList;
      const add: EnderecoType = {
        idPessoa: usuario.id,
        ativo: true,
        bairro: bairroRef.current,
        cep: cepRef.current,
        cidade: cidadeRef.current,
        complemento: complementoRef.current,
        estado: estadoRef.current,
        local: ruaRef.current,
        numero: numeroRef.current,
        principal: principalRef.current,
        id: usuario.idEmpresa,
      };
      const filter = endList.find((item) => item.local === add.local);
      if (!filter) {
        endList.push(add);
        setEnderecoList(endList);
        setViaCepEnd({
          bairro: "",
          cep: "",
          complemento: "",
          ddd: "",
          gia: "",
          ibge: "",
          localidade: "",
          logradouro: "",
          siafi: "",
          uf: "",
        });
      }
    }
  };

  const adicionarContato = () => {
    const contList: ContatoType[] = contatoList;
    const add: ContatoType = {
      idPessoa: usuario.id,
      ativo: true,
      id: usuario.idEmpresa,
      cargo: cargoContatoRef.current,
      nome: nomeContatoRef.current,
      email: emailContatoRef.current,
      principal: principalContatoRef.current,
      telefone: telefoneContatoRef.current,
    };
    if (nomeContatoRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o nome do contato");
    } else {
      contList.push(add);
      setContatoList(contList);
    }
  };

  const adcionarConta = () => {
    const contaFinanceiroList: PessoaContaFinanceiro[] = contaList;
    const add: PessoaContaFinanceiro = {
      agencia: agenciaRef.current,
      banco: bancoRef.current,
      descricao: descricaoRef.current,
      documento: documentoContaRef.current,
      numero: numeroContaRef.current,
      obs: obsRef.current,
      tipo: tipoRef.current,
      pessoaId: "",
      tipoPessoa: tipoPessoaRef.current,
      titular: titularRef.current,
      id: '',
    };
    console.log(add);
    if (titularRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o nome do titular");
      return;
    } 

    if (bancoRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o banco da conta");
      return;
    } 

    if (descricaoRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente a descrição da conta");
      return;
    } 

    if (documentoContaRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o documento associado a conta");
      return;
    } 

    if (numeroContaRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o numero da conta");
      return;
    } 

    if (tipoRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o tipo da conta");
      return;
    } 

    if (tipoPessoaRef.current.value === "") {
      showError("Erro!", "Preencha Corretamente o tipo de pessoa da conta");
      return;
    } 

    contaFinanceiroList.push(add);
    setContaList(contaFinanceiroList);
  }

  const deleteEnd = (end: EnderecoType) => {
    const list = enderecoList;
    const data = list.filter((item) => item !== end);
    setEnderecoList(data);
  };

  const deleteContato = (contato: ContatoType) => {
    const list = contatoList;
    const data = list.filter((item) => item !== contato);
    setContatoList(data);
  };

  const deleteConta = (conta: PessoaContaFinanceiro) => {
    const list = contaList;
    const data = list.filter((item) => item !== conta);
    setContaList(data);
  };

  const closeErrorPessoa = () => {
    setError(false);
  };

  const validateInput = (ref: any, title: string, message: string) => {
    if (ref.current === undefined || ref.current.value === "") {
      showError(title, message);
      return false;
    }
    return true;
  };
  
  const saveCliente = async () => {
    if (!validateInput(classificacaoRef, "Erro!", "Preencha Corretamente a Classificação da Pessoa")) {
      return;
    }
    if (!validateInput(idTipoRef, "Erro!", "Preencha Corretamente o Tipo da Pessoa")) {
      return;
    }
    if (!validateInput(nomeClinteRef, "Erro!", "Preencha Corretamente o Nome")) {
      return;
    }


  
    if (client) {
      await updatePerson();
    } else {
      await insertPerson();
    }
  };

  const updatePerson = async () => {  
    setLoading(true);

    const update = {
      id: client.id,
      nome: nomeClinteRef.current.value ?? nomeClinteRef.current,
      classificacao: classificacaoRef.current.value ?? classificacaoRef.current,
      contribuinte: contribuinteRef.current.value ?? contribuinteRef.current,
      documento: documentoRef.current.value ?? documentoRef.current,
      idEmpresa: usuario.idEmpresa ?? idTipoRef.current,
      idTipo: idTipoRef.current.value ?? idTipoRef.current,
      inscricaoEstadual:
        inscricaoEstadualRef.current.value ?? inscricaoEstadualRef.current,
      inscricaoMunicipal:
        inscricaoMunicipalRef.current.value ?? inscricaoMunicipalRef.current,
      nomeFantasia: nomeFantasiaRef.current.value ?? nomeFantasiaRef.current,
      razaoSocial: razaoSocialRef.current.value ?? razaoSocialRef.current,
    };
    const isAgency = classificacaoList.find((a) =>  a.id === classificacaoRef.current);
    if(isAgency.nome.includes('ncia')) {
      if(contatoList.length === 0) {
        showError("Erro", "Você deve preencher o contato para a agência corretamente");
        setLoading(false);
        return;
      }
    }

    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/pessoa/" + client.id,
      update
    );
    if (response.data === true) {
      if (enderecoList.length > 0) {
        enderecoList.forEach(async (item) => {
          if (item.id !== usuario.idEmpresa) {
            await axios.get(
              process.env.REACT_APP_API_URL + "/endereco/delete/" + item.id
            );
          }

          const addEnd = {
            ativo: true,
            bairro: item.bairro,
            cep: item.cep,
            cidade: item.cidade,
            complemento: item.complemento,
            estado: item.estado,
            idPessoa: client.id,
            local: item.local,
            numero: item.numero,
            principal: item.principal,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/endereco/create",
            addEnd
          );
        });
      }

      if (contatoList.length > 0) {
        contatoList.forEach(async (item) => {
          if (item.id !== usuario.idEmpresa) {
            await axios.get(
              process.env.REACT_APP_API_URL + "/contato/delete/" + item.id
            );
          }

          const addContato = {
            ativo: item.ativo,
            idPessoa: client.id,
            cargo: item.cargo,
            nome: item.nome,
            email: item.email,
            principal: Boolean(item.principal),
            telefone: item.telefone,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/contato/create",
            addContato
          );
        });
      }


      if(contaList.length > 0) {
      const resp =  await axios.delete(
          process.env.REACT_APP_API_URL + "/pessoa/conta/" + client.id
        )
        if(resp){
          contaList.forEach(async (c) => {
            const addConta : PessoaContaFinanceiro = {
              ...c,
              pessoaId : client.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/pessoa/conta",
              addConta
            );
          });
        }
      }

      if (pessoaFilial.length > 0) {
        await axios.delete(
          process.env.REACT_APP_API_URL + "/pessoa/filial/" + client?.id
        );
        pessoaFilial.forEach(async (p) => {
          const addFilial = {
            idEmpresa: usuario.idEmpresa,
            idFilial: p.idFilial,
            idPessoa: client.id,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/pessoa/filial",
            addFilial
          );
        });
      } else  {
        let tipoCliente = false;
        const filter = classificacaoList?.find((val) => val.id === classificacaoRef.current);
        if (
          filter?.nome.toLocaleLowerCase().includes("cliente") ||
          filter?.nome.toLocaleLowerCase().includes("ncia") ||
          filter?.nome.toLocaleLowerCase().includes("fornecedor")
        ) {
          tipoCliente = true;
        }
        if(tipoCliente) {
          await axios.delete(
            process.env.REACT_APP_API_URL + "/pessoa/filial/" + client?.id
          );
          filial.forEach(async (item) => {
            const addFilial = {
              idEmpresa: usuario.idEmpresa,
              idFilial: item.id,
              idPessoa: client.id,
            };
            await axios.post(
              process.env.REACT_APP_API_URL + "/pessoa/filial",
              addFilial
            );
          });
        }
      }

      showFormPessoa(false);
      await loadData();
      setLoading(false);
    }

    setLoading(false);
  };

  const insertPerson = async () => {
    setLoading(true);
    const addPessoa = {
      nome: nomeClinteRef.current.value ?? nomeClinteRef.current,
      classificacao: classificacaoRef.current.value ?? classificacaoRef.current,
      contribuinte: contribuinteRef.current.value ?? contribuinteRef.current,
      documento: documentoRef.current.value ?? documentoRef.current,
      idEmpresa: usuario.idEmpresa ?? idTipoRef.current,
      idTipo: idTipoRef.current.value ?? idTipoRef.current,
      inscricaoEstadual:
        inscricaoEstadualRef.current.value ?? inscricaoEstadualRef.current,
      inscricaoMunicipal:
        inscricaoMunicipalRef.current.value ?? inscricaoMunicipalRef.current,
      nomeFantasia: nomeFantasiaRef.current.value ?? nomeFantasiaRef.current,
      razaoSocial: razaoSocialRef.current.value ?? razaoSocialRef.current,
    };

    const isAgency = classificacaoList.find((a) =>  a.id === classificacaoRef.current);
    if(isAgency.nome.includes('ncia')) {
      if(contatoList.length === 0) {
        showError("Erro", "Você deve preencher o contato para a agência corretamente");
        setLoading(false);
        return;
      }
    }

    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/pessoa",
      addPessoa
    );

    if (response.data) {
      const retorno: PessoaType = response.data;
      if (enderecoList.length > 0) {
        enderecoList.forEach(async (item) => {
          const addEnd = {
            ativo: true,
            bairro: item.bairro,
            cep: item.cep,
            cidade: item.cidade,
            complemento: item.complemento,
            estado: item.estado,
            idPessoa: retorno.id,
            local: item.local,
            numero: item.numero,
            principal: Boolean(item.principal),
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/endereco/create",
            addEnd
          );
        });
      }

      if (contatoList.length > 0) {
        contatoList.forEach(async (item) => {
          const addContato = {
            ativo: item.ativo,
            idPessoa: retorno.id,
            cargo: item.cargo,
            nome: item.nome,
            email: item.email,
            principal: item.principal,
            telefone: item.telefone,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/contato/create",
            addContato
          );
        });
      }

      if (pessoaFilial.length > 0) {
        pessoaFilial.forEach(async (p) => {
          const addFilial = {
            idEmpresa: usuario.idEmpresa,
            idFilial: p.idFilial,
            idPessoa: retorno.id,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/pessoa/filial",
            addFilial
          );
        });
      }

      if(contaList.length > 0) {
        contaList.forEach(async (c) => {
          const addConta : PessoaContaFinanceiro = {
            ...c,
            pessoaId : retorno.id,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/pessoa/conta",
            addConta
          );
        })
      }
      // } else  {
      //   let tipoCliente = false;
      //   const filter = classificacaoList?.find((val) => val.id === classificacaoRef.current);
      //   if (
      //     filter?.nome.toLocaleLowerCase().includes("cliente") ||
      //     filter?.nome.toLocaleLowerCase().includes("ncia") ||
      //     filter?.nome.toLocaleLowerCase().includes("fornecedor")
      //   ) {
      //     tipoCliente = true;
      //   }
      //   if(tipoCliente) {
      //     filial.forEach(async (item) => {
      //       const addFilial = {
      //         idEmpresa: usuario.idEmpresa,
      //         idFilial: item.id,
      //         idPessoa: retorno.id,
      //       };
      //       await axios.post(
      //         process.env.REACT_APP_API_URL + "/pessoa/filial",
      //         addFilial
      //       );
      //     });
      //   }
      // }
      showFormPessoa(false);
      await loadData();
      setLoading(false);
    }
    setLoading(false);
  };

  const editPessoa = async (item: PessoaType) => {
 
    setClient(item);

    nomeFantasiaRef.current = item.nomeFantasia;
    nomeClinteRef.current = item.nome;
    classificacaoRef.current = item.classificacaoId;
    idTipoRef.current = item.idTipo;
    documentoRef.current = item.documento;
    razaoSocialRef.current = item.razaoSocial;
    inscricaoEstadualRef.current = item.inscricaoEstadual;
    inscricaoMunicipalRef.current = item.inscricaoMunicipal;
    contribuinteRef.current = item.contribuinte.toString();
    setContaList(item.PessoaContaFinanceiro);
    await loadEndereco(item.id);
    await loadContato(item.id);
    await loadPessoaFilial(item.id);
    showFormPessoa(true);
  };  

  const showDeletePessoa = (item: PessoaType) => {
    setClient(item);
    setShowDelete(true);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const deletePessoa = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/pessoa/" + client?.id
    );
    if (response.data === true) {
      setLoading((prev) => (prev = false));
      showFormPessoa(false);
      setClient(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const changeItemPessoa = (item: ContatoType, index: number) => {
    const newItems: ContatoType[] = contatoList.map((existingItem, idx) => {
      if (index === idx) {
        return item;
      }
      if (item.principal) {
        existingItem.principal = false;
      }
      return existingItem;
    });

    setContatoList(newItems);
  };

  const changeFilial = (item: any[]) => {
    const list: EmpresaFilial[] = [];
    item?.forEach((val) => {
      const existe = pessoaFilial?.find(
        (valor) => valor.idFilial === val?.value
      );
      if (!existe) {
        const item: EmpresaFilial = {
          id: "",
          idEmpresa: usuario.idEmpresa,
          idFilial: val?.value,
          idPessoa: "",
        };

        list.push(item);
      } else {
        list.push(existe);
      }
    });
    setPessoaFilial(list);
  };

  useEffect(() => {
    const initialize = async () => {
      await Promise.all([
        loadData(),
        loadClassificaocao(),
        loadClientType(),
        loadEmpresas(),
      ]);
    }
    initialize()
  }, []);

  return {
    usuario,
    loading,
    showPessoa,
    errorCliente,
    showDelete,
    clientes,
    cancelRefPessoa,
    showFormPessoa,
    saveCliente,
    nomeClinteRef,
    idTipoRef,
    classificacaoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    contribuinteRef,
    classificacaoList,
    tipoPessoaList,
    cepRef,
    ruaRef,
    numeroRef,
    complementoRef,
    bairroRef,
    cidadeRef,
    estadoRef,
    principalRef,
    enderecoList,
    loadCEP,
    viaCepEnd,
    adicionarEndereco,
    deleteEnd,
    contatoList,
    deleteContato,
    adicionarContato,
    cancelContatoRef,
    cancelPessoaRef,
    closeErrorPessoa,
    editPessoa,
    deletePessoa,
    cancelDeleteRef,
    showDeletePessoa,
    closeDelete,
    client,
    nomeContatoRef,
    cargoContatoRef,
    telefoneContatoRef,
    emailContatoRef,
    principalContatoRef,
    changeItemPessoa,
    filial,
    pessoaFilial,
    changeFilial,
    errorTitleCliente,
    errorMsgCliente,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta
  };
};
export default useClients;
